// removed by extract-text-webpack-plugin
module.exports = {"form-radio":"CheckoutSurvey__form-radio__593bd62c","form-radio-label-text":"CheckoutSurvey__form-radio-label-text__593bd62c","container":"CheckoutSurvey__container__593bd62c","radioOption":"CheckoutSurvey__radioOption__593bd62c","textareaWrapper":"CheckoutSurvey__textareaWrapper__593bd62c","submit":"CheckoutSurvey__submit__593bd62c"};


//////////////////
// WEBPACK FOOTER
// ./src/abandonedCheckout/components/CheckoutSurvey.scss
// module id = ./src/abandonedCheckout/components/CheckoutSurvey.scss
// module chunks = 4